import React from 'react';

import { Navigate, Outlet, useNavigation } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

import { AUTH_SIGN_IN } from '@app/routes/paths/auth';
import { NavigationState } from '@app/routes/types';
import { type FeatureFlagValue } from '@app/store/types/features';
import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

interface FeatureRoutesProps {
    feature: FeatureFlagValue;
    logInRequired?: boolean;
    redirectTo?: string;
}

// This component checks for a feature flag
export const FeatureRoutes = ({ feature, logInRequired, redirectTo }: FeatureRoutesProps) => {
    const isAuthenticated = useAuthTokens((state) => state.isAuthenticated);
    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);
    const navigation = useNavigation();

    const goTo404 = !feature && navigation.state === NavigationState.Idle;

    if (logInRequired && (!isAuthenticated || !isRegisteredUser)) {
        return <Navigate to={AUTH_SIGN_IN} />;
    }

    return !goTo404 ? <Outlet /> : <Navigate to={redirectTo ?? '/404'} relative="path" />;
};
